
<template>
  <page class="page">
    <mobile-form></mobile-form>
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import MobileForm from '@/views/ab/MobileForm.vue';

export default {
  components: {
    Page,
    MobileForm,
  },
};
</script>

<style lang="scss" scoped>
.page {
  margin-top: 0;
}
</style>